import React from 'react'
import { IoStar, IoStarHalf } from 'react-icons/io5'

function ProductDetiles() {
  return (
    <div className='con my-8 text-center' id='c'>
      <h1 className=' font-bold my-4'>Customer Reviews</h1>
      <div className='flex justify-center'>
        <IoStar className=' text-accent'/>
        <IoStar className=' text-accent' />
        <IoStar className=' text-accent' />
        <IoStar className=' text-accent' />
        <IoStarHalf className=' text-accent'/>
        <p className=' font-medium text-[16px] ml-2 text-gray-500'>4.5 out of 5</p>
      </div>
      <span className=' text-gray-500 text-[14px]'>Based on 90 reviews</span>
      <div className='flex text-[14px] justify-center box-border'>
        <div className='flex'>
        <IoStar className=' text-accent'/>
        <IoStar className=' text-accent' />
        <IoStar className=' text-accent' />
        <IoStar className=' text-accent' />
        <IoStar className=' text-accent' />
        </div>
        
        <p className='text-accent w-[100px] h-3 bg-gray-500 ml-[50px]'>
          <span className='w-[95%] bg-accent block h-[100%]'></span>
        </p>
        <span className=' ml-[44px]'>80</span>
      </div>
      <div className='flex text-[14px] justify-center box-border'>
        <div className='flex'>
        <IoStar className=' text-accent'/>
        <IoStar className=' text-accent' />
        <IoStar className=' text-accent' />
        <IoStar className=' text-accent' />
        <IoStar className='text-gray-500' />
        </div>
        
        <p className='text-accent w-[100px] h-3 bg-gray-500 ml-[50px]'>
          <span className='w-[8%] bg-accent block h-[100%]'></span>
        </p>
        <span className=' ml-[50px]'>5</span>
      </div>
      <div className='flex text-[14px] justify-center'>
        <div className='flex'>
        <IoStar className=' text-accent'/>
        <IoStar className=' text-accent' />
        <IoStar className=' text-accent' />
        <IoStar className=' text-gray-500' />
        <IoStar className='text-gray-500' />
        </div>
        
        <p className='text-accent w-[100px] h-3 bg-gray-500 ml-[50px]'>
          <span className='w-[3%] bg-accent block h-[100%]'></span>
        </p>
        <span className=' ml-[50px]'>2</span>
      </div>
      <div className='flex text-[14px] justify-center'>
        <div className='flex'>
        <IoStar className=' text-accent'/>
        <IoStar className=' text-accent' />
        <IoStar className=' text-gray-500' />
        <IoStar className=' text-gray-500' />
        <IoStar className='text-gray-500' />
        </div>
        
        <p className='text-accent w-[100px] h-3 bg-gray-500 ml-[50px]'>
          <span className='w-[0%] bg-accent block h-[100%]'></span>
        </p>
        <span className=' ml-[50px]'>0</span>
      </div>
      <div className='flex text-[14px] justify-center'>
        <div className='flex'>
        <IoStar className=' text-accent'/>
        <IoStar className=' text-gray-500' />
        <IoStar className=' text-gray-500' />
        <IoStar className=' text-gray-500' />
        <IoStar className='text-gray-500' />
        </div>
        
        <p className='text-accent w-[100px] h-3 bg-gray-500 ml-[50px]'>
          <span className='w-[5%] bg-accent block h-[100%]'></span>
        </p>
        <span className=' ml-[50px]'>3</span>
      </div>

    </div>
  )
}

export default ProductDetiles